"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerserkAbilityHandler = exports.BerserkActorAbilityFactory = exports.BerserkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class BerserkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Berserk;
        this.__typeName = "Berserk";
    }
}
exports.BerserkAbilityArgs = BerserkAbilityArgs;
let BerserkActorAbilityFactory = class BerserkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Berserk", "AllAllies", 3);
    }
};
BerserkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Berserk")
], BerserkActorAbilityFactory);
exports.BerserkActorAbilityFactory = BerserkActorAbilityFactory;
let BerserkAbilityHandler = class BerserkAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const ally of allies) {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ally,
                        duration: Duration_1.Duration.Turns(3),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.StunImmunityEffectArgs(),
                            new core_1.CharmImmunityEffectArgs(),
                            new core_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ally, 10, "Power")),
                            new core_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(ally, 10, "Focus")),
                        ], false),
                    });
                }
            }
        });
    }
};
BerserkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Berserk)
], BerserkAbilityHandler);
exports.BerserkAbilityHandler = BerserkAbilityHandler;
